<template>
    <Link :href="'/evento/' + item.slug" class="tarjeta-evento">
    <div class="tarjeta-evento__img">
        <img :src="item.portada.small" :alt="item.nombre" width="350" height="230" loading="lazy">
    </div>
    <div class="tarjeta-evento__color azul">
        <div class="tarjeta-evento__info">
            <h6>{{ item.nombre }}</h6>
            <div class="tarjeta-evento__hora">
                <span>{{ item.lugar }}</span>
            </div>
        </div>
        <div class="tarjeta-evento__fecha">
            <span class="tarjeta-evento__mes">{{ $filters.getShortDate(item.fecha_desde) }}</span>
            <span class="separador" v-if="item.fecha_desde != item.fecha_hasta">-</span>
            <span class="tarjeta-evento__mes" v-if="item.fecha_desde != item.fecha_hasta">{{
                    $filters.getShortDate(item.fecha_hasta)
            }}</span>
        </div>
    </div>
    </Link>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    props: {
        item: Object,
    },
    components: { Link }
}
</script>
<style scoped>
.separador{
    font-size: 23px;
    line-height: .5rem;
}
h6 {
    max-height: initial;
    font-size: 18px;
    margin-top: 0;
    line-height: 1.3em;
    margin-bottom: 0;
}
.tarjeta-evento {
    height: auto;
}
</style>
